import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const createBooking = (data) =>
  axios.post(`${API}/bookings`, data).then((r) => r.data);

export const createSampleRequest = (data) =>
  axios.post(`${API}/sample-requests`, data).then((r) => r.data);

export const createContact = (data) =>
  axios.post(`${API}/contact`, data).then((r) => r.data);

export const createRoomShare = (data) =>
  axios.post(`${API}/visualise/share`, data).then((r) => r.data);

export const createGuideRequest = (data) =>
  axios.post(`${API}/guide-requests`, data).then((r) => r.data);

// ── Admin (shared secret via X-Admin-Key header) ──────────────────
const adminHeaders = (key) => ({ "X-Admin-Key": key });

export const adminPing = (key) =>
  axios.get(`${API}/admin/ping`, { headers: adminHeaders(key) }).then((r) => r.data);

export const adminInbox = (key) =>
  axios.get(`${API}/admin/inbox`, { headers: adminHeaders(key) }).then((r) => r.data);

export const adminUpdateStatus = (key, kind, id, status) =>
  axios
    .patch(`${API}/admin/records/${kind}/${id}/status`, { status }, { headers: adminHeaders(key) })
    .then((r) => r.data);

export const adminSendDigest = (key) =>
  axios.post(`${API}/admin/send-digest`, {}, { headers: adminHeaders(key) }).then((r) => r.data);

export const adminUpdateNote = (key, kind, id, note) =>
  axios
    .patch(`${API}/admin/records/${kind}/${id}/note`, { note }, { headers: adminHeaders(key) })
    .then((r) => r.data);

export const adminTestEntries = (key) =>
  axios.get(`${API}/admin/test-entries`, { headers: adminHeaders(key) }).then((r) => r.data);

export const adminArchiveTestEntries = (key) =>
  axios.post(`${API}/admin/test-entries/archive`, {}, { headers: adminHeaders(key) }).then((r) => r.data);

export const adminRestoreArchived = (key) =>
  axios.post(`${API}/admin/archived/restore`, {}, { headers: adminHeaders(key) }).then((r) => r.data);
